var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4355 2.95781V16.4156C21.4355 18.068 20.2297 19.3734 18.7513 19.3734H12.7118L7.47337 23.7647C7.14309 24.0342 6.67146 23.767 6.67146 23.31V19.3734H2.64515C1.16674 19.3734 -0.0390625 18.0258 -0.0390625 16.4156V2.95781C-0.0390625 1.30547 1.16674 0 2.64515 0H18.7504C20.2653 0 21.4355 1.34766 21.4355 2.95781Z",
    fill: "#3ECF8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.3f15202c99c8984757f2c18e0bed1b2d.svg";
export { ForwardRef as ReactComponent };